/**
 * Also used for quote application schema.
 */
const ORIGINATION_FIELDS = {
  ID: 'id',
  COVERAGE_TYPES: 'coverageTypes',
  EFFECTIVE_DATE: 'effectiveDate',
  AUTO_EFFECTIVE_DATE: 'autoEffectiveDate',
  APPLICANTS: 'applicants',
  ADDRESSES: 'addresses',
  VEHICLES: 'vehicles',
  INCIDENTS: 'incidents',
  CLAIMS: 'claims',
  PROPERTIES: 'properties',
  ACCOUNT_ID: 'accountId',
  EXTERN_ORIGINATOR_ID: 'externOriginatorId',
  PROPERTY_INFO: 'homeCoverageInfo',
  PROPERTY_INCIDENTS: 'propertyIncidents',
  POOLS: 'pools',
  AUTO_INFO: 'autoCoverageInfo',
  ATTRIBUTION: 'attribution',
  EXTRA_FIELDS: 'extraFields'
};

const APPLICANT_FIELDS = {
  // ID
  TAG: 'applicantTag',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  DOB: 'dob',
  GENDER: 'gender',
  EMAIL: 'primaryEmail',
  PHONE: 'phoneNumbers',
  EDUCATION: 'education',
  INDUSTRY: 'industry',
  ROLE: 'role',
  SSN: 'taxId',
  APPLICANT_TYPE: 'applicantType',
  MARITAL_STATUS: 'maritalStatus',
  ADDRESS_TAG: 'currentAddressTag',
  PREVIOUS_ADDRESS_TAG: 'previousAddressTag',
  ADDRESS_ID: 'addressId', // Primary residence
  PREVIOUS_ADDRESS_ID: 'previousAddressId',
  MONTHS_AT_ADDRESS: 'monthsAtCurrentAddress',
  RELATIONSHIP: 'relationToMainApplicant',
  DRIVERS_LICENSE_NUMBER: 'driversLicenseNumber',
  DRIVERS_LICENSE_STATE: 'driversLicenseState',
  DRIVERS_LICENSE_DATE: 'licenseDate',
  RESIDENCE_TYPE: 'residenceType',
  LICENSE_STATUS: 'licenseStatus',
  LICENSE_SUSPENDED_WITHIN_MIN_TIME: 'licenseSuspendedWithinMinTime',
  STUDENT: 'student',
  GPA: 'gpa',
  MILITARY: 'military',
  DEFENSIVE_DRIVING_COURSE: 'defensiveDrivingCourse',
  DRIVING_COURSE_DATE: 'drivingCourseDate',
  DRIVING_MONITOR_OK: 'drivingMonitorOk',
  YEARS_CONTINUOUSLY_INSURED_AUTO: 'yearsContinuouslyInsuredAsDriver',
  YEARS_CONTINUOUSLY_INSURED: 'yearsContinuouslyInsured',
  PREFERRED_COMMUNICATION_METHOD: 'preferredCommunicationMethod',
  EXCLUDED_REASON: 'excludedReason',
  UNINSURED_REASON: 'uninsuredReason',
  IMPAIRMENT: 'uncompensatedMedicalImpairment',
  STUDENT_AWAY: 'studentAwayAtSchool',
  GOOD_STUDENT: 'goodStudent'
};

const ADDRESS_FIELDS = {
  ADDRESS_TAG: 'addressTag',
  ADDRESS_TYPE: 'addressType',
  COMPOSITE: 'composite',
  STREET_NUMBER: 'streetNumber',
  STREET_NAME: 'streetName',
  MUNICIPALITY_LEVEL3: 'municipalityLevel3',
  MUNICIPALITY_LEVEL2: 'municipalityLevel2',
  MUNICIPALITY_LEVEL1: 'municipalityLevel1',
  MUNICIPALITY_LEVEL1_CODE: 'municipalityLevel1Code',
  POSTAL_CODE: 'postalCode',
  UNIT_NUMBER: 'houseNumber',
  FLOOR_NUMBER: 'floorNumber'
};

// Deprecated. Use CLAIM_FIELDS.
const PROPERTY_INCIDENT_FIELDS = {
  INCIDENT_DATE: 'incidentDate',
  INCIDENT_DESC: 'incidentDesc',
  INCIDENT_AMOUNT: 'incidentAmount'
};

const CLAIM_FIELDS = {
  // ID
  LINE_OF_BUSINESS: 'lineOfBusiness',
  DATE: 'date',
  TYPE: 'type',
  AMOUNT: 'amount',
  CATASTROPHIC: 'catastrophic',
  PROPERTY_ID: 'propertyId'
};

const POOL_FIELDS = {
  INGROUND: 'inGround',
  ACCESS_RESTRICTED: 'accessRestricted',
  SLIDE: 'slide',
  DIVING_BOARD: 'divingBoard'
};

const PROPERTY_FIELDS = {
  // ID
  ADDRESS_ID: 'addressId', // Insured Property
  INSURED_PROPERTY_ADDRESS: 'insuredPropertyAddress', // An address tag @deprecated
  DWELLING_TYPE: 'dwellingType',
  SQUARE_FOOTAGE: 'squareFootage',
  PROPERTY_TYPE: 'propertyType',
  PLUMBING_TYPE: 'plumbingType',
  YEAR_PLUMBING_UPDATED: 'plumbingYear',
  PLUMBING_UPDATE_TYPE: 'plumbingUpdateType',
  YEAR_ELECTRIC_UPDATED: 'yearElectricUpdated',
  ELECTRIC_UPDATE_TYPE: 'electricUpdateType',
  INSURED_IS_PROPERTY_OWNER: 'insuredIsPropertyOwner',
  PRIMARY_HEATING_SOURCE: 'primaryHeatingSource',
  PROPERTY_DISCOUNTS: 'propertyDiscounts',
  FIRE_ALARM: 'fireAlarm',
  BURGLAR_ALARM: 'burglarAlarm',
  HOME_BUSINESSES: 'homeBusinesses',
  HAS_PET: 'hasPet',
  ANIMALS: 'animals',
  ANIMAL_INJURY: 'animalInjury',
  BREEDS_OF_DOGS: 'breedsOfDogs',
  MIN_MONTHS_WITH_CURRENT_INSURER: 'minMonthsWithCurrentInsurer',
  CURRENT_POLICY_EXPIRATION: 'currentPolicyExpiration',
  RECENT_CLAIM: 'recentClaim',
  POLICY_CANCELED: 'policyCanceled',
  LOAN_NUMBER: 'primaryLoanNumber',
  LOAN_AMOUNT: 'primaryLoanAmount',
  PRIMARY_MORTGAGE_HOLDER: 'primaryMortgageHolder',
  PRIMARY_MORTGAGE_CITY: 'primaryMortgageCity',
  PRIMARY_MORTGAGE_STATE: 'primaryMortgageState',
  NUMBER_OF_STORIES: 'stories',
  NUMBER_OF_RESIDENTS: 'numberOfResidents',
  NUMBER_OF_CHILDREN: 'numberOfChildren',
  NUMBER_OF_NON_DRIVING_CHILDREN: 'numberOfNonDrivingChildren',
  NUMBER_OF_MORTGAGES: 'numberOfMortgages',
  FOUNDATION: 'foundation',
  CONSTRUCTION_TYPE: 'constructionType',
  ROOF_TYPE: 'roofType',
  ROOF_SHAPE: 'roofShape',
  YEAR_HEATING_UPDATED: 'yearHeatingUpdated',
  HEATING_UPDATE_TYPE: 'heatingUpdateType',
  STORM_PROTECTION: 'stormProtection',
  WITHIN_MILES_OF_FIRE_STATION: 'withinMilesOfFireStation',
  WITHIN_FEET_OF_FIRE_HYDRANT: 'withinFeetOfFireHydrant',
  WITHIN_MILES_OF_COAST: 'withinMilesOfCoast',
  ROOF_YEAR: 'roofYear',
  ROOF_UPDATE_TYPE: 'roofUpdateType',
  OWNERSHIP_YEAR: 'ownershipYear',
  YEAR_BUILT: 'yearBuilt',
  FUEL_TANKS_ON_PREMISES: 'fuelTanksOnPremises',
  HAS_UNDERGROUND_FUEL_TANK: 'hasUndergroundFuelTank',
  PRIMARY_TANK_ABOVE_GROUND: 'primaryTankAboveGround',
  CURRENT_INSURER: 'currentInsurer',
  MOVE_IN_DATE: 'moveInDate',
  LINE_OF_BUSINESS: 'lineOfBusiness',
  PURCHASE_DATE: 'purchaseDate',
  MONTHS_OCCUPIED: 'monthsOccupied',
  DANGEROUS_ANIMAL: 'dangerousAnimal',
  HALF_BATHS: 'halfBaths',
  FULL_BATHS: 'fullBaths',
  FAMILIES_ON_PREMISES: 'familiesResidingOnPremises',
  EXTERIOR_WALL_MATERIAL: 'exteriorWallMaterial',
  NUMBER_OF_SOLAR_PANELS: 'numberOfSolarPanels',
  ELECTRICAL_JUNCTION: 'electricalJunction',
  GARAGES: 'garages',
  GARAGE_CONSTRUCTION: 'construction',
  GARAGE_NUMBER_OF_CARS: 'numberOfCars',
  POOLS: 'pools',
  POOL_IN_GROUND: 'inGround',
  POOL_ACCESS_RESTRICTED: 'accessRestricted',
  FLOOD_ZONE: 'floodZone',
  HAS_FLOOD_POLICY: 'hasFloodPolicy',
  CURRENT_POLICY_NUMBER: 'currentPolicyNumber'
};

const AUTO_FIELDS = {
  RESIDING_AT_PRIMARY_ADDRESS_FOR_MIN_TIME: 'residingAtPrimaryAddressForMinTime',
  CURRENT_INSURER: 'currentInsurer',
  MIN_MONTHS_WITH_CURRENT_INSURER: 'minMonthsWithCurrentInsurer',
  CURRENT_POLICY_EXPIRATION: 'currentPolicyExpiration',
  CURRENT_POLICY_NUMBER: 'currentPolicyNumber',
  RECENT_CLAIM: 'recentClaim',
  POLICY_CANCELED: 'policyCanceled',
  CURRENT_BODILY_INJURY_PER_PERSON: 'currentBodilyInjuryPerPerson',
  CURRENT_BODILY_INJURY_PER_ACCIDENT: 'currentBodilyInjuryPerAccident',
  TORT_LIMITATION: 'tortLimitation'
};

const VEHICLE_FIELDS = {
  // ID
  MAKE: 'make',
  MODEL: 'model',
  SUBMODEL: 'subModel',
  YEAR: 'year',
  VIN: 'vin',
  MILEAGE: 'mileage',
  VEHICLE_OWNERSHIP_STATUS: 'vehicleOwnershipStatus',
  VEHICLE_PURCHASE_DATE: 'vehiclePurchaseDate',
  VEHICLE_ACTIVITES: 'vehicleActivities',
  MILES_DRIVEN_PER_YEAR: 'milesDrivenPerYear',
  VEHICLE_USE: 'vehicleUse',
  PRIMARY_DRIVER: 'primaryDriver',
  OTHER_DRIVERS: 'otherDrivers',
  PARKED_AT_PRIMARY_ADDRESS: 'parkedAtPrimaryAddress',
  PRIMARY_GARAGE: 'primaryGarage',
  GARAGE_ADDRESS_ID: 'garageAddressId',
  FINANCING_LIEN_HOLDER: 'financingLienHolder',
  REGISTERED_STATE: 'registeredState',
  OWNER: 'owner',
  VEHICLE_TYPE: 'vehicleType',
  APPLICANT_ID: 'applicantId', //primary driver
  ANNUAL_MILES: 'annualMiles',
  DAYS_DRIVEN_PER_WEEK: 'daysDrivenPerWeek',
  COMMUTE_DISTANCE: 'commuteDistance',
  EXCLUDED: 'excluded'
};

const INCIDENT_FIELDS = {
  DRIVER: 'incidentDriver', // Tag, deprecated.
  TYPE: 'incidentType',
  ACCIDENT_DESC: 'autoAccidentDesc',
  CLAIM_DESC: 'autoClaimDesc', // Deprecated, auto claims now held in `claims` entity.
  VIOLATION_DESC: 'autoViolationDesc',
  INCIDENT_DATE: 'incidentDate',
  APPLICANT_ID: 'applicantId', // Driver associated with this incident.
  RESULTED_IN_BI_LOSS: 'resultedInBiLoss',
  RESULTED_IN_DEATH: 'resultedInDeath',
  RESULTED_IN_PIP_LOSS: 'resultedInPipLoss'
};

const PHONE_FIELDS = {
  PHONE_TYPE: 'phoneType',
  NUMBER: 'number'
};

const IV_REPORT_FIELDS = {
  COVERAGES: 'coverages',
  REQUIRED_COVERAGES: 'requiredCoverages',
  INSURANCE_COMPANY: 'insuranceCompany',
  VEHICLE: 'vehicle',
  STATE: 'state',
  VIN_ON_POLICY: 'vinOnPolicy',
  VALID: 'valid',
  SENT: 'sent',
  SENT_BY: 'sentBy',
  CARRIER_POLICY_NUMBER: 'carrierPolicyNumber',
  VIEWED: 'viewed'
};

module.exports = {
  ORIGINATION_FIELDS,
  APPLICANT_FIELDS,
  ADDRESS_FIELDS,
  PROPERTY_INCIDENT_FIELDS,
  PROPERTY_FIELDS,
  POOL_FIELDS,
  AUTO_FIELDS,
  VEHICLE_FIELDS,
  INCIDENT_FIELDS,
  PHONE_FIELDS,
  IV_REPORT_FIELDS,
  CLAIM_FIELDS
};
